import { Avatar, IconButton, makeStyles } from "@material-ui/core";
import simbolo from "../../../../../assets/images/home/simbolo.png";
import React, { useEffect, useState } from "react";
import { ArrowForward, Check } from "@material-ui/icons";
import { useUpdateUser } from "../../../../../hooks/useUpdateUser";
import useGoToPage from "../../../../../hooks/useGoToPage";
import ButtonMedita from "../../../../../components/ButtonMedita";
import { useHistory } from "react-router-dom";
import api from "../../../../../core/api";
import { useSnackbar } from "notistack";
import SubscriptionFilters from "../../../../../components/StepperMobile/components/SubscriptionFilters";
import useGetPlans from "../../../../../hooks/useGetPlans";

const useStyles = makeStyles({
  leftSectionTwo: {
    height: "100%",
    maxWidth: "85%",
    margin: "auto",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  viewFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginLeft: "4%",
    marginRight: "4%",
    marginBottom: "5%",
  },
  view: {
    width: "88%",
    margin: "auto",
    marginTop: "50px",
    marginBottom: "50px",
  },
  avatar: {
    width: "64px",
    height: "64px",
    borderRadius: "16px",
  },
  premiumPage: {
    alignItems: "center",
    borderRadius: "1px",
    backgroundColor: "#fff",
    margin: "10px",
    paddingTop: "30px",
    position: "relative",
  },
  topArea: {
    height: "30px",
    marginLeft: "10px",
    marginRight: "10px",
  },
  topLinearGradient: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    background: "#6eb64b",
    background: "linear-gradient(-90deg, #6eb64b 0.00%, #009daa 100.00%)",
  },
  topText: {
    fontFamily: "Century Gothic",
    color: "#fff",
    fontSize: 16,
    marginTop: 1,
    textAlign: "center",
    padding: 10,
  },
  typeArea: {
    height: "15%",
    borderTopLeftRadius: "1%",
    borderTopRightRadius: "1%",
    display: "flex",
    flexDirection: "column",
    paddingVertical: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  discountBanner: {
    position: "absolute",
    top: 30,
    right: 0,
    width: "auto",
    height: "4%",
    background: "#6eb64b",
    background: "linear-gradient(-90deg, #6eb64b 0.00%, #009daa 100.00%)",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  bannerLinearGradient: {
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  offerPercentText: {
    color: "#fff",
    fontSize: 20,
    marginTop: "0.5%",
  },
  typeText: {
    fontFamily: "Century Gothic",
    fontSize: 25,
    opacity: 1,
    letterSpacing: 1.5,
    color: "#6D6E70",
    fontWeight: "normal",
    marginTop: "3%",
  },
  titleAndValueArea: {
    display: "flex",
    flexDirection: "row",
  },
  titleText: {
    fontFamily: "Century Gothic",
    fontSize: 10,
    opacity: 1,
    textAlign: "left",
    letterSpacing: 1.5,
    color: "#6eb64b",
    fontWeight: "normal",
  },
  valueText: {
    fontFamily: "Century Gothic",
    fontSize: 30,
    opacity: 1,
    textAlign: "left",
    letterSpacing: 1.5,
    color: "#6eb64b",
    fontWeight: "700",
  },
  frequencyView: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  frequencyText: {
    fontFamily: "Century Gothic",
    fontSize: 10,
    opacity: 1,
    textAlign: "left",
    letterSpacing: 1.5,
    color: "#6eb64b",
    fontWeight: "normal",
  },
  viewArea: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-end",
    paddingTop: "15px",
    width: "85%",
    margin: "auto",
    borderBottom: "1px solid #E5EAF4",
    paddingBottom: "30px",
    marginBottom: "15px",
  },
  titleArea: {
    fontFamily: "Century Gothic",
    fontSize: 16,
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "left",
    color: "#5a7184",
  },
  viewDescription: {
    paddingTop: "15px",
    width: "85%",
    margin: "auto",
    paddingBottom: "15px",
    marginBottom: "15px",
  },
  viewNotice: {
    backgroundColor: "#F3FAF7",
    padding: 15,
    borderRadius: 15,
    marginBottom: "4%",
  },
  titleNotice: {
    fontFamily: "Century Gothic",
    fontSize: 13,
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "center",
    color: "#183B56",
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: "3%",
  },
  titleAreaList: {
    fontFamily: "Century Gothic",
    fontSize: 14,
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "left",
    color: "#5a7184",
    marginTop: "1%",
    width: "60%",
  },
  textItem: {
    fontFamily: "Century Gothic",
    fontSize: 15,
    fontWeight: "bold",
    fontStyle: "normal",
    textAlign: "left",
    color: "#183b56",
  },
  button: { width: "65%" },
  icon: { color: "#fff" },
  iconTwo: { color: "#000" },
  bold: { fontWeight: "bold" },
});

const CardsPlan = ({}) => {
  const classes = useStyles();
  const goToPage = useGoToPage();
  const history = useHistory();
  const [subsSite, setSubsSite] = useState(true);
  const [statusPlan, setStatusPlan] = useState("NOTPENDING");
  const plano = localStorage.getItem("plano");
  const token = localStorage.getItem("token");
  const { plans, isLoading, refetch } = useGetPlans();

  const descriptionsPlan = [
    {
      id: 1,
      plan_name: "Medita.Bem",
      two_name: "Free",
      title: "FREE",
      description:
        "Experimente alguns conteúdos gratuitos de meditação guiada, músicas, mantras e áudios e dê o primeiro passo para dias mais leves e equilibrados.",
      introduction: "",
      items: [
        {
          title: "Acesso aos conteúdos gratuitos",
          description:
            "Explore, salve e crie playlists sem anúncios ou interrupções.",
        },
      ],
      notice: (
        <div>
          <span className={classes.titleNotice}>
            Primeira vez por aqui? Experimente
            <span className={classes.bold}>
              {" "}
              todos os conteúdos do MeditaBem por 14 dias
            </span>{" "}
            .
          </span>
        </div>
      ),
      outcome: "",
      activePlan: plano === "F" || plano === "N",
    },
    {
      id: 2,
      price: plans[0]?.value || "-",
      frequency: "mensal",
      plan_name: "Medita.Bem+",
      two_name: "Bem+",
      title: "PREMIUM",
      description:
        "Transforme sua rotina com acesso completo a meditações guiadas, exercícios, yoga, músicas, mantras e vídeos que trazem mais equilíbrio e bem-estar.",
      introduction: "",
      items: [
        {
          title: "Acesso aos conteúdos premium",
          description: "Tenha o universo completo de bem-estar ao seu alcance.",
        },
        {
          title: "Sem anúncios",
          description: "Foco total no que realmente importa: você.",
        },
        {
          title: "Salve seus conteúdos favoritos",
          description:
            "Mantenha sua coleção de meditações e práticas sempre à mão.",
        },
        {
          title: "Crie playlists ilimitadas",
          description:
            "Personalize sua prática com a sequência perfeita para relaxar, meditar ou energizar seu dia.",
        },
      ],
      notice: (
        <div>
          <span className={classes.titleNotice}>
            Comece sua
            <span className={classes.bold}> jornada</span> de
            <span className={classes.bold}> bem-estar</span> e encontre o seu
            refúgio de
            <span className={classes.bold}>
              {" "}
              paz e equilíbrio todos os dias
            </span>
            .
          </span>
        </div>
      ),
      outcome: "",
      activePlan: plano === "M",
    },
    {
      id: 3,
      price: plans[1]?.value || "-",
      frequency: "anual",
      plan_name: "Medita.Sempre",
      two_name: "Sempre",
      title: "PREMIUM",
      description:
        "Assine o plano anual e garanta 12 meses de transformação completa com benefícios exclusivos para uma vida de mais equilíbrio, paz e bem-estar.",
      introduction: "",
      items: [
        {
          title: "Acesso aos conteúdos premium",
          description:
            "Imersão total no bem-estar, com práticas transformadoras.",
        },
        {
          title: "Sem anúncios",
          description: "Sua jornada de equilíbrio sem interrupções.",
        },
        {
          title: "Salve seus conteúdos favoritos",
          description:
            "Tenha sua própria biblioteca de bem-estar sempre ao seu alcance.",
        },
        {
          title: "Crie playlists ilimitadas",
          description:
            "Medite, relaxe e organize suas práticas favoritas para cada momento do seu dia.",
        },
        {
          title: "Benefícios exclusivos",
          description:
            "Descontos em cursos, eventos e parcerias que vão além do app, ajudando a transformar sua vida por completo.",
        },
      ],
      notice: (
        <div>
          <span className={classes.titleNotice}>
            Invista no seu bem-estar a longo prazo e
            <span className={classes.bold}>
              {" "}
              aproveite os benefícios exclusivos{" "}
            </span>
            criados para deixar sua jornada cada vez
            <span className={classes.bold}> mais leve e equilibrada</span>.
          </span>
        </div>
      ),
      outcome: "",
      activePlan: plano === "Y",
      showDiscountBanner: true,
      percentage: "60",
    },
  ];

  const UpdateUser = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const res = await useUpdateUser();
    if (res?.subscription_assas_id) {
      try {
        const result = JSON.parse(res?.subscription_assas_id);
        const planBody = result.filter((r) => r.status === "PENDING");
        if (
          planBody.length > 0 &&
          planBody[planBody.length - 1].status === "PENDING"
        ) {
          setStatusPlan("PENDING");
        }
      } catch (error) {}
    }
  };
  useEffect(() => {
    UpdateUser();
  }, []);

  const { enqueueSnackbar } = useSnackbar();
  const snackbar = (message) => {
    enqueueSnackbar(`${message}`, {
      variant: "error",
      anchorOrigin: {
        horizontal: "right",
        vertical: "top",
      },
    });
  };

  const getSubscrition = async () => {
    const id = localStorage.getItem("id");
    if (id) {
      try {
        await api.get(`/subscriptions/users/${id}`).then(async ({ data }) => {
          if (data.transaction && data.transaction?.platform !== "site") {
            setSubsSite(false);
          }
        });
      } catch (e) {
        // snackbar("Ops.. algo de errado aconteceu. Tente novamente mais tarde!");
      }
    }
  };

  useEffect(() => {
    getSubscrition();
  }, []);

  const [planActive, setPlan] = useState(
    plano === "M" ? 1 : plano === "Y" ? 2 : 0
  );

  return (
    <div className={classes.view}>
      <div className={classes.viewFilter}>
        <SubscriptionFilters
          onSelectFilter={setPlan}
          selectedPlan={planActive}
        />
      </div>
      <div className={classes.leftSectionTwo}>
        {[descriptionsPlan[planActive]].map((plan) => (
          <div style={{ marginTop: !plan.showDiscountBanner ? "30px" : 0 }}>
            {plan.showDiscountBanner ? (
              <div className={classes.topArea}>
                <div className={classes.topLinearGradient}>
                  <span className={classes.topText}>MAIS POPULAR</span>
                </div>
              </div>
            ) : null}
            <div className={classes.premiumPage}>
              <div className={classes.typeArea}>
                {plan.showDiscountBanner ? (
                  <div className={classes.discountBanner}>
                    <div className={classes.bannerLinearGradient}>
                      <span className={classes.offerPercentText}>
                        {plan.percentage}% OFF
                      </span>
                    </div>
                  </div>
                ) : null}
                <Avatar
                  className={classes.avatar}
                  alt={`icon-simbolo`}
                  src={simbolo}
                />
                <span className={classes.typeText}>
                  medita
                  <span style={{ color: "#009DAA" }}>{plan.two_name}</span>
                </span>
                <div className={classes.titleAndValueArea}>
                  <span className={classes.titleText}>R$</span>
                  <div className={classes.frequencydiv}>
                    <span className={classes.valueText}>
                      {plan.price ? plan.price : "0,00"}
                    </span>
                    <span className={classes.frequencyText}>
                      {plan.frequency ? `/${plan.frequency}` : null}
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.viewArea}>
                <span className={classes.titleArea}>{plan.description}</span>
              </div>
              <div className={classes.viewDescription}>
                {plan.items.map((item, index) => (
                  <div className={classes.listItem} key={index}>
                    <Check
                      style={{
                        fontSize: 15,
                        borderRadius: 10,
                        padding: 2,
                        color: "#36B37E",
                        backgroundColor: "#E1F4EC",
                        marginRight: "5px",
                      }}
                    />

                    <div>
                      <span className={classes.textItem}>{item.title}</span>
                      <br />
                      <span className={classes.titleAreaList}>
                        {item.description}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className={classes.viewDescription}>
                {plan.notice && (
                  <div className={classes.viewNotice}>{plan.notice}</div>
                )}

                <div
                  style={{
                    paddingTop: 20,
                    marginTop: 10,
                    borderRadius: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {statusPlan !== "PENDING" &&
                    (!token ||
                      (plano !== "S" &&
                        plano !== "G" &&
                        ((plan.id === 1 && plan.activePlan) ||
                          plan.id !== 1))) && (
                      <ButtonMedita
                        width="auto"
                        variant={
                          plan.showDiscountBanner ? "contained" : "outlined"
                        }
                        className={classes.button}
                        disabled={plan.activePlan || (plan.id === 1 && !!token)}
                        onClick={() => {
                          if (plans.length < 2 && plan.id !== 1)
                            return snackbar(
                              "Ocorreu um erro. Tente novamente mais tarde"
                            );
                          if (!token)
                            return goToPage(`/cadastre-se?id=${plan.id}`);
                          if (!subsSite)
                            return snackbar(
                              "Acesse o Aplicativo Medita para concluir essa ação"
                            );
                          history.push(`/medita-bem-planos?id=${plan.id}`);
                        }}
                      >
                        {plan.activePlan ? (
                          "Seu Plano atual"
                        ) : (
                          <>
                            <div />
                            Escolher Plano
                            <IconButton
                              size="large"
                              className={
                                plan.showDiscountBanner
                                  ? classes.icon
                                  : classes.iconTwo
                              }
                            >
                              <ArrowForward />
                            </IconButton>
                          </>
                        )}
                      </ButtonMedita>
                    )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardsPlan;
